import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/user/',
    component:layout,
    children:[
        {name: ' 用户列表', path: 'index', component: ()=>_import('index')},
        // add route here
    ]
}